import $ from 'jquery';
import { isInsideReactComponent, isInsideSelectrize } from '../_utils';
// 'field-datepicker',
// 'field-dropzone',
// 'field-creditCard',
// 'field-autocomplete',
// 'field-rating'
// 'field-address',
// 'field-range',
// 'field-custom-select'

// let timeout = {};
export const messages = {
    requiredField: 'This field is required',
};
export const changeQty = ($control) => {
    var $field = $control.closest('.field'),
        $input = $field.find('.field__input'),
        amount = Number($input.data('amount')) || 1,
        value = Number($input.val()),
        type = $control.is('.field__control--plus') ? 'plus' : 'minus';

    if (!$input.is('[data-qty]')) return;

    if (type == 'plus') {
        $input.val(value + amount);
    } else {
        $input.val(value - amount);
    }

    $input.trigger('change');
};
export const updateAutoResize = ($input) => {
    if (!$input.length) return;

    $input.each(function() {
        var $el = $(this),
            $auxDiv,
            autoResizeClass = 'field__input--autoresize',
            value =
                $el.val().replace(/ /g, '&nbsp;') || $el.attr('placeholder');

        // if SELECT
        if ($el.is('select')) {
            value = $el
                .find('option')
                .eq($el[0].selectedIndex)
                .text();
        }

        if ($el.siblings('.' + autoResizeClass).length) {
            $auxDiv = $el.siblings('.' + autoResizeClass);
        } else {
            $auxDiv = $(
                '<div class="field__input field__input--autoresize"></div>'
            );
            // insert
            $el.before($auxDiv);
        }

        $auxDiv.html(value);
    });
};
export const selectTabSelect = ($input) => {
    var index = $input[0].selectedIndex,
        $tabs = $($input.data('tab')),
        $allTabs = $tabs.children(),
        $tab = $allTabs.eq(index);

    $allTabs.removeClass('active');

    if ($tab.length) {
        $tab.addClass('active');
    }
};
export const selectTabInput = ($input) => {
    var $tab = $($input.data('tab'));

    if ($input.prop('checked')) {
        $tab.show();
    } else {
        $tab.hide();
    }

    $tab.siblings().hide();
};
export const selectTab = ($input) => {
    var type = $input.attr('type');

    if (type == 'checkbox' || type == 'radio') {
        selectTabInput($input);
    } else if ($input.is('select')) {
        selectTabSelect($input);
    }
};
export const selectURL = ($input) => {
    var url = $input.val();
    window.location.href = url;
};
export const edit = ($trigger) => {
    var $field = $trigger.closest('.field'),
        $input = $field.find('.field__input'),
        type = $trigger.data('edit-field') || false;

    // remove attr
    $input.removeAttr('readonly disabled');

    // keep original value
    if (!$input.data('value')) {
        $input.data('value', $input.val());
    }

    if (type) {
        $input.data('type', $input.attr('type'));
        $input.attr('type', type);
    }

    // reset field
    $input.val('');

    // bind blur function
    $input.off('blur.edit-field');
    $input.on('blur.edit-field', function() {
        if (!$input.val()) {
            $input.val($input.data('value')).attr('readonly', 'readonly');
            $input.attr('type', $input.data('type'));
        }
    });
};
export const formatValue = ($el, event) => {
    $el.each(function() {
        var $input = $(this);
        if (isInsideReactComponent($(this))) return;
        if (isInsideSelectrize($(this))) return;

        // fulldate
        if ($input.is('[data-fulldate]')) {
            formatFullDate($input, event);
        }
        // expiry date
        else if ($input.is('[data-expiry]')) {
            formatExpiryDate($input, event);
        }
        // number
        else if ($input.is('[data-number]')) {
            formatNumberValue($input);
        }
        // qty
        else if ($input.is('[data-qty]')) {
            formatQtyValue($input);
        }

        toggleEmpty($input);
    });
};
export const formatFullDate = ($input, event) => {
    var value = $input.val() || '',
        length = value.length,
        pos = 0;

    if (event) {
        pos = event.target.selectionStart;
    }
    $input.attr('maxlength', 10);
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d{2})(\d)/, '$1/$2');
    value = value.replace(/(\d{2}\/\d{2})(\d)/, '$1/$2');
    value = value.substr(0, 10);
    $input.val(value);
    // test position after valus has changed
    pos = pos - (length - $input.val().length);
    // select new range
    $input[0].setSelectionRange(pos, pos);
};
export const formatExpiryDate = ($input, event) => {
    var value = $input.val() || '',
        length = value.length,
        pos = 0;

    if (event) {
        pos = event.target.selectionStart;
    }
    $input.attr('maxlength', 5);
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d{2})(\d)/, '$1/$2');
    value = value.substr(0, 5);
    $input.val(value);
    // test position after valus has changed
    pos = pos - (length - $input.val().length);
    // select new range
    $input[0].setSelectionRange(pos, pos);
};
export const formatNumberValue = ($input) => {
    var value = $input.val() || '';

    value = value.replace(/\D/g, '');

    $input.val(value);
};
export const formatQtyValue = ($input) => {
    // var qtyData = String($input.data('qty')).split(','),
    var qtyData = [$input.attr('min'), $input.attr('max')],
        min = Number(qtyData[0]),
        max = Number(qtyData[1]),
        value = $input.val();

    value = Number(value);

    if (value < min) {
        value = min;
    } else if (value > max) {
        value = max;
    }

    $input.val(value);
};
export const validateIdentical = ($input, displayAlert) => {
    var $form = $input.closest('.form'),
        $identical = $form.find('[name=' + $input.data('identical') + ']'),
        $theSecondField = $input.data('identical-confirm') ? $input : $identical,
        identicalMessage = $theSecondField.data('identical-message') || '';

    if ($input.is($theSecondField)) {
        if (
            $input.val().length &&
            $identical.val().length &&
            $input.val() != $identical.val()
        ) {
            if (identicalMessage) {
                $theSecondField.data('alert', identicalMessage);
            }

            if (displayAlert) {
                toggleSuccess(false, $theSecondField);
                toggleError(true, $theSecondField, identicalMessage != '');
            }

            return false;
        }

        $input.removeData('alert');
        $identical.removeData('alert');

        toggleSuccess(true, $identical);
        toggleError(false, $identical);
    } else {
        toggleSuccess(true, $identical);
        toggleError(false, $identical);
    }

    return true;
};
export const validateEmail = ($input) => {
    var value = $input.val();
    // if (!/[A-Za-z0-9_.\-]+@([A-Za-z0-9_\-]+\.)+[A-Za-z]{2,4}/.test(value)) {
    if (!/[A-Za-z0-9_.-]+@([A-Za-z0-9_-]+\.)+[A-Za-z]{2,4}/.test(value)) {
        return false;
    }
    return true;
};
export const validateCheckbox = ($input) => {
    if (!$input.prop('checked')) {
        return false;
    }
    return true;
};
export const validateEmpty = ($input) => {
    var value = $input.val();
    if (value === '' || value === null) {
        return false;
    }
    return true;
};
export const validateExpiry = ($input) => {
    var value = $input.val();
    if (!/^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/.test(value)) {
        return false;
    }
    return true;
};
export const validateFulldate = ($input) => {
    var value = $input.val();
    if (
        !/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
            value
        )
    ) {
        return false;
    }
    return true;
};
export const validateMinMax = ($input, displayAlert) => {
    var value = Number($input.val()),
        // var value = $input.val() || false,
        min = Number($input.attr('min')),
        max = Number($input.attr('max'));

    if (value === false) {
        return false;
    }
    if (min && value < min) {
        $input.data('alert', 'The MINIMUM value is ' + min + '.');
        if (displayAlert) {
            toggleError(true, $input, true);
        }
        return false;
    } else if (max && value > max) {
        $input.data('alert', 'The MAXIMUM value is ' + max + '.');
        if (displayAlert) {
            toggleError(true, $input, true);
        }
        return false;
    }

    $input.removeData('alert');

    return true;
};
export const validateLength = ($input, displayAlert) => {
    var value = Number($input.val().length),
        // var value = $input.val() || false,
        min = Number($input.attr('min-char')),
        max = Number($input.attr('max-char'));

    if (value === false) {
        return false;
    }
    if (min && value < min) {
        $input.data('alert', 'Must be at least ' + min + ' characters long.');
        if (displayAlert) {
            toggleError(true, $input);
        }
        return false;
    } else if (max && value > max) {
        $input.data(
            'alert',
            'Must not be more than ' + max + ' characters long.'
        );
        if (displayAlert) {
            toggleError(true, $input);
        }
        return false;
    }

    $input.removeData('alert');

    return true;
};
export const validateGoogleAddress = ($input) => {
    if (!$input.data('address')) {
        return false;
    }
    return true;
};
export const validateCreditCard = ($input) => {
    if (!$input.data('card')) {
        return false;
    }
    return true;
};
export const validate = ($input, alert) => {
    var required = $input.attr('required'),
        type = $input.attr('type'),
        flag = true;

    // not required
    if (
        !required &&
        ((type != 'checkbox' && !$input.val()) || type == 'checkbox')
    ) {
        return flag;
    }

    // type
    switch (type) {
        // email
        case 'email':
            flag = validateEmail($input);
            if (flag && $input.data('identical')) {
                flag = validateIdentical($input);
            }
            break;
        case 'checkbox':
            flag = validateCheckbox($input);
            break;
        // default
        default:
            // extra conditions
            // regions
            if ($input.is('[data-google-regions]')) {
                flag = validateGoogleAddress($input);
            }
            // address
            else if ($input.is('[data-google-address]')) {
                flag = validateGoogleAddress($input);
            }
            // credit card
            else if ($input.is('[data-credit-card]')) {
                flag = validateCreditCard($input);
            }
            // fulldate
            else if ($input.is('[data-fulldate]')) {
                flag = validateFulldate($input);
            }
            // expiry
            else if ($input.is('[data-expiry]')) {
                flag = validateExpiry($input);
            }
            // number
            else if ($input.is('[data-number]')) {
                flag = validateMinMax($input, alert);
            }
            // minimum length
            else if ($input.attr('min-char') || $input.attr('max-char')) {
                // flag = validateLength($input, alert);
                flag = validateLength($input);
            } else {
                flag = validateEmpty($input);
            }

            // identical
            if (flag && $input.data('identical')) {
                flag = validateIdentical($input);
            }

            break;
    }

    return flag;
};
export const toggleValidation = ($input, displayAlert = false) => {
    var required = $input.attr('required');

    // not required
    if (!required && !$input.val()) {
        toggleError(false, $input);
        return;
    }

    if (validate($input, true)) {
        toggleSuccess(true, $input);
        toggleError(false, $input);
    } else {
        toggleSuccess(false, $input);
        toggleError(true, $input, displayAlert);
    }
};
export const toggleSuccess = (flag, $input) => {
    var successClass = 'field--success',
        $field = $input.closest('.field');

    if (flag) {
        $field.addClass(successClass);
    } else {
        $field.removeClass(successClass);
    }
};
export const toggleError = (flag, $input, alert) => {
    var errorClass = 'field--alert',
        $field = $input.closest('.field');

    if (flag) {
        $field.addClass(errorClass);
        if (alert) {
            toggleAlert(true, $input);
        }
    } else {
        $field.removeClass(errorClass);
        toggleAlert(false, $input);
    }
};
export const toggleAlert = (flag, $input) => {
    var $field = $input.closest('.field'),
        $oldAlert = $field.find('.field__alert'),
        message = $input.data('alert') || messages.requiredField,
        $alert = $oldAlert.length
            ? $oldAlert
            : $('<div class="field__alert" />');

    $alert.text(message);

    if (flag) {
        $field.append($alert);
        $alert.fadeIn(300);
    } else {
        $field.find('.field__alert').remove();
    }
};
export const toggleEmpty = ($input) => {
    var $field = $input.closest('.field'),
        emptyClass = 'field--filled';
    if ($input.val() !== '') {
        $field.addClass(emptyClass);
    } else {
        $field.removeClass(emptyClass);
    }
};
export const toggleFocus = ($input, flag) => {
    var $field = $input.closest('.field'),
        focusClass = 'field--focus';

    if ($input.is('[readonly]')) return;

    if (flag) {
        $field.addClass(focusClass);
    } else {
        $field.removeClass(focusClass);
    }
};
export const toggleChecked = ($input) => {
    if (!$input.length) return;

    $input.each(function() {
        var $el = $(this),
            $block = $el.closest('[data-block]'),
            $form = $block.length ? $block : $el.closest('.form'),
            $label = $el.closest('.field'),
            $fieldBox = $label.closest('.field-box'),
            type = $el.attr('type'),
            name = $el.attr('name');

        if (isInsideReactComponent($(this))) return;
        if (isInsideSelectrize($(this))) return;

        if (!$el.prop('checked')) {
            $label.removeClass('field--checked');
            $fieldBox.removeClass('field-box--filled');
        } else {
            if (type === 'radio') {
                $form
                    .find('input[name=' + name + ']')
                    .closest('.field')
                    .removeClass('field--checked');
                $form
                    .find('input[name=' + name + ']')
                    .closest('.field-box')
                    .removeClass('field-box--filled');
            }
            $label.addClass('field--checked');
            $fieldBox.addClass('field-box--filled');
        }
    });
};
export const getValue = ($input) => {
    var value = $input.val(),
        realValue = $input.data('real-value'),
        type = $input.attr('type');

    // radio
    if (type === 'radio') {
        if ($input.prop('checked')) {
            return value;
        }
        return;
    }
    // checkbox
    if (type === 'checkbox') {
        return $input.prop('checked');
    }
    // address
    else if (typeof $input.attr('data-google-address') !== 'undefined') {
        // return $input.data('address');
        return $.extend({}, true, $input.data('address'), { original: value });
    } else {
        return typeof realValue !== 'undefined' ? realValue : value;
        // return value;
    }
};
export const binds = () => {
    // ---------------- input tab
    $('body').on('change.tab', '[data-tab]', function() {
        selectTab($(this));
    });

    // ---------------- autoresize
    $('body').on(
        'keyup.autoresize change.autoresize paste.autoresize input.autoresize',
        'input[data-autoresize]',
        function() {
            var $el = $(this);

            // prevent multiple events
            // clearTimeout(timeout.autoresize);
            // timeout.autoresize = setTimeout(function () {
            updateAutoResize($el);
            // }, 100);
        }
    );
    updateAutoResize($('[data-autoresize]'));

    // ---------------- responsive select url
    $('body').on('change.field', '[data-selecturl]', function() {
        selectURL($(this));
    });

    // ---------------- edit field
    $('body').on('click.field', '[data-edit-field]', function() {
        edit($(this));
    });

    // ---------------- check field trigger
    $('body').on('toggleEmpty', 'input, select, textarea', function() {
        if (isInsideReactComponent($(this))) return;
        if (isInsideSelectrize($(this))) return;
        toggleEmpty($(this));
    });

    // ---------------- qty input
    $('body').on('click.field', '.field--qty .field__control', function() {
        if (isInsideReactComponent($(this))) return;
        if (isInsideSelectrize($(this))) return;
        changeQty($(this));
    });

    // ---------------- inputs keyup
    $('body').on(
        'keyup.field change.field paste.field input.field',
        'input, select, textarea',
        function(event) {
            if (isInsideReactComponent($(this))) return;
            if (isInsideSelectrize($(this))) return;

            var $el = $(this);
            // prevent multiple events
            // clearTimeout(timeout.formatValue);
            // timeout.formatValue = setTimeout(function () {
            formatValue($el, event);
            // toggleValidation($el, false, false);
            toggleError(false, $el);
            // }, 100);
        }
    );
    formatValue($('input, select, textarea').not('.selectric-input'));

    // ---------------- inputs focus
    $('body')
        .on('focusin.field', 'input, select, textarea', function() {
            if (isInsideReactComponent($(this))) return;
            // if (isInsideSelectrize($(this))) return;
            toggleFocus($(this), true);
        })
        .on('focusout.field', 'input, select, textarea', function(event) {
            if (isInsideReactComponent($(this))) return;
            if (isInsideSelectrize($(this))) return;

            var $el = $(this);

            toggleFocus($el, false);
            formatValue($el, event);
            toggleValidation($el, true);
        });

    // ---------------- input check
    $('body').on(
        'click.checkInput',
        'input[type=checkbox], input[type=radio]',
        function() {
            if (isInsideReactComponent($(this))) return;
            if (isInsideSelectrize($(this))) return;
            toggleChecked($(this));
        }
    );
    toggleChecked($('input[type=checkbox], input[type=radio]'));
};
